//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[],[[["materialName","material","newMaterialName"],"CreateMaterial",{},1,0],[["materialTag","objects"],"AssignMaterial",{},2,0],[["materialTag"],"DeleteMaterial",{},1,0],[["objects"],"RemoveMaterial",{},1,0],[["materialCount","materialTags","materialNames"],"GetMaterialsInPart",{},0,0],[["materialType","materialCount","materialTags","materialNames"],"GetMaterialsInPartByType",{},1,0],[["name"],"FindObject",{R_:{found:"Display.VisualMaterial"}},1,0],[["skipAppearanceMat","materialTag","materialName"],"GetMaterialByEntity",{},1,1],[["entity","skipAppearanceMat","materialTag","materialName"],"GetMaterialByEntity2",{},2,0]],[]];
SPLM.Display.VisualMaterialCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Display.VisualMaterialCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;